module.exports = __webpack_public_path__ + "img/zhu2.d858bc8f.png";